import React from 'react';
import PropTypes from 'prop-types';

const GradientSVG = props => {
    const { startColor, endColor, idCSS, rotation } = props;

    return (
        <svg style={{ height: 0 }}>
            <defs>
                <linearGradient id={idCSS} gradientTransform={`rotate(${rotation})`}>
                    <stop offset="0%" stopColor={startColor} />
                    <stop offset="100%" stopColor={endColor} />
                </linearGradient>
            </defs>
        </svg>
    );
};

GradientSVG.propTypes = {
    startColor: PropTypes.string.isRequired,
    endColor: PropTypes.string.isRequired,
    idCSS: PropTypes.string.isRequired,
    rotation: PropTypes.string.isRequired,
};

export default GradientSVG;
